export default __webpack_public_path__ + "static/media/typewriter.0a82b792.png";